import { Entrance } from "@/components/home/Entrance";
import { FoundationMap } from "@/components/home/FoundationMap";
import { OrdoDiscovery } from "@/components/home/OrdoDiscovery";
import { CommercialApplication } from "@/components/home/CommercialApplication";
import { ProductOrigination } from "@/components/home/ProductOrigination";
import { Participation } from "@/components/home/Participation";

export default function Home() {
  return (
    <>
      <Entrance />
      <FoundationMap />
      <OrdoDiscovery />
      <CommercialApplication />
      <ProductOrigination />
      <Participation />
    </>
  );
}
